import React, { Component } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Col, Container, Row, Card, CardBody, Button } from 'reactstrap';
// import { LoadPage, ShowSpinner } from '../../redux/SqlReport';
// import { showNotification } from '../../redux/Notification';
import { changeBlogTag } from '../../redux/CmnBlog';
import { GetBlogList, GetBlogTagList } from '../../services/CmnBlogService';
import { toBlogDateFormat, toDate } from '../../helpers/formatter';
import fintruxLogo from '../../img/fintruxLogo.png';
import Particles from 'react-particles-js';
import log from '../../helpers/logger';
import MetaTags from 'react-meta-tags';
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { isNullOrUndefined } from 'util';

class Home extends Component {
  constructor(props) {
    super(props);
    const blogTagId = this.props.CmnBlog.blogTagId || 0;

    this.state = {
      limit: 10,
      latestBlog: {},
      blogList: [],
      pastBlogList: [],
      blogTagList: [],
      activeId: blogTagId,
      loadingFirstSec: true
    }

    // this.onTagChange = this.onTagChange.bind(this);
    this.onTagChange = this.onTagChange.bind(this);
    this.loadBlogList(blogTagId, []);

    GetBlogTagList().then(
      (resp) => {
        this.setState({
          blogTagList: resp.data.data
        });
      },
      (error) => {
        console.log(error);
      }
    )
  }

  onTagChange(blogTagId) {
    this.props.changeBlogTag(blogTagId);
  }

  onTagChange(blogTagId) {
    if (this.state.activeId === blogTagId) return;
    this.setState({ activeId: blogTagId, loading: true, limit: 10 });

    this.loadBlogList(blogTagId, []);
  }

  loadBlogList(blogTagId, currentList) {
    GetBlogList(this.state.limit,currentList.length, blogTagId).then(
      (resp) => {
        console.log(resp.data.data.length);
        this.setState({
          latestBlog: resp.data.data.length > 0 ? resp.data.data[0] : null,
          blogList: [...currentList, ...resp.data.data],
          blogAmount: resp.data.data.length,
          loadingFirstSec: false
        });
      },
      (error) => {
        console.log(error);
      }
    )
  }


  componentDidMount() {
    document.title =  "FintruX Blog";
    // GetBlogList(10, 0, 0).then(
    //   (resp) => {
    //     this.setState({
    //       latestBlog: resp.data.data[0],
    //       blogList: resp.data.data,
    //       loadingFirstSec: false
    //     });
    //   },
    //   (error) => {
    //     console.log(error);
    //   }
    // )

    // GetBlogList(10, 0, 0).then(
    //   (resp) => {
    //     this.setState({
    //       pastBlogList: resp.data.data
    //     });
    //   },
    //   (error) => {
    //     console.log(error);
    //   }
    // )
  }

  componentDidUpdate(prevprops, prevstates) { }

  render() {
    const latestBlog = this.state.latestBlog;

    const blogList = this.state.blogList;
    const pastBlogList = this.state.pastBlogList;
    const blogTagList = this.state.blogTagList;

    return (
      <div>
        {/* <MetaTags>
          <meta property="og:title" content="FintruX Blog" />
          <meta property="og:description" content="Smart Financial and Business Solutions to Foster SME Growth, Built On The Blockchain." />
          <meta property="og:image" content="http://blog.fintrux.com/metaImg.jpg" />
          <meta property="og:url" content="http://blog.fintrux.com" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="FintruX Blog" />
          <meta name="twitter:description" content="Smart Financial and Business Solutions to Foster SME Growth, Built On The Blockchain." />
          <meta name="twitter:image" content="http://blog.fintrux.com/metaImg.jpg" />
          <meta name="twitter:site" content="http://blog.fintrux.com" />
        </MetaTags> */}
        {/* <div className="homeTopBg"> */}
        <div>
          <div className="overlay-bubble">
            <div className="overlay-bubble-1"></div>
            <div className="overlay-bubble-2"></div>
            <div className="overlay-bubble-3"></div>
            <div className="overlay-bubble-4"></div>
            <div className="overlay-bubble-5"></div>
            <div className="overlay-bubble-6"></div>
          </div>
          {/* <Particles className="homeParticles" params={{
            particles: {
              number: { value: 30, density: { enable: true, value_area: 800 } },
              color: { value: "#ffffff" },
              opacity: { value: 0.5, random: false, anim: { enable: false, speed: 1, opacity_min: 0.5, sync: false } },
              shape: { type: "circle", stroke: { width: 10, color: "#42b0a3" }, polygon: { nb_sides: 5 } },
              move: { enable: true, speed: 8, direction: "none", random: false, straight: false, out_mode: "out", bounce: false, attract: { enable: false, rotateX: 600, rotateY: 1200 } },
              interactivity: { detect_on: "canvas", events: { onhover: { enable: false, mode: "repulse" }, resize: true }, modes: { repulse: { distance: 400, duration: 0.4 }, } },
              line_linked: { shadow: { enable: true, color: "#3CA9D1", blur: 5 } }
            }
          }} /> */}
          <Container>
            <Row>
              <Col md={12} lg={12} className="LatestSec">
                {this.state.loadingFirstSec === true && <Row>
                    <Col md={6} lg={6}><SkeletonTheme color="#E8F0F5" ><div className="imgSkeletonSec"><Skeleton /></div></SkeletonTheme></Col>
                    <Col md={6} lg={6}><SkeletonTheme color="#E8F0F5" ><div className="cntSkeletonSec"><Skeleton count={7} /></div></SkeletonTheme></Col>
                  </Row>
                }
                {this.state.loadingFirstSec === false &&
                  <Row>
                    <Col md={12} lg={12}>
                      <div>
                        <div className="blogTagContainer">
                          <Button className={"btn outline btn-lg " + (0 === this.state.activeId ? "selected" : "")} onClick={() => { this.onTagChange(0) }}>All</Button>
                          {blogTagList.map((item, i) => {
                            return <Button key={i} onClick={() => { this.onTagChange(item.BlogTagId) }} className={"btn outline btn-lg " + (item.BlogTagId === this.state.activeId ? "selected" : "")}>{item.BlogTagName}</Button>
                          }
                          )}
                        </div>
                      </div>
                      <hr />
                      <br />
                    </Col>
                    
                    <Col md={8} lg={8}>
                      <div className="topSecImg">
                        <a>
                          <img src={latestBlog.PicMed ? "data:application/base64;base64," + latestBlog.PicMed : ""} alt="product-img" /></a>
                      </div>
                    </Col>
                    <Col md={4} lg={4}>
                      <div className="topSection">
                        <div className="text-middle">
                          <h5 className="bLogDate">{toBlogDateFormat(latestBlog.BlogDate)}</h5>
                          <h1 className='product-card__title'>
                            <Link className="link" to={'/BlogDtl/' + latestBlog.BlogId  + '/' + latestBlog.BlogTitle.split(' ').join('')}>
                              <span className="underlineTopHome">{latestBlog.BlogTitle}</span>
                            </Link>
                          </h1>
                          <p className="blogDesc">{latestBlog.BlogDesc}</p>
                        </div>
                        {/* <div className="extra-grey"></div> */}
                      </div>
                      <div className="botSection">
                        {/* <img src={fintruxLogo} alt="product-img" /> */}
                        <h6 className='minsRead'>By FintruX Team • 5 mins read</h6>
                        {
                          latestBlog.BlogTagName ?
                            (<div className="blogTagContainer"><a className="HomeFirstBlogTag" href={"BlogList/"} onClick={() => { this.onTagChange(latestBlog.BlogTagId) }}>{latestBlog.BlogTagName}</a></div>) : null
                        }
                      </div>
                    </Col>
                  </Row>
                }
              </Col>
            </Row>
          </Container>
        </div>
          <Container>
            <Row>
              {/* <Col md={12}>
                <h2 className='page-title page-title--not-last homeSubTitle'>RECENT BLOGS</h2>
              </Col> */}
              <Col md={12} lg={12} className='no-padding'>
                {/* <BlogItems /> */}
                <div className='catalog-items__wrap latestItems'>
                  <div className='catalog-items'>
                    {blogList.map((item, i) => {
                      if (i !== 0) {
                        return <div className='catalog-item' key={i}>
                          <div className='catalog-item__img-wrap'>
                            <div className="imageMidSec">
                              <img className='catalog-item__img' src={item.PicMed ? ("data:application/base64;base64," + item.PicMed) : ""} alt='catalog-item-img' />
                            </div>
                          </div>
                          <div className='catalog-item__info'>
                            <h4>
                              <Link className="link" to={'/BlogDtl/' + item.BlogId + '/' + item.BlogTitle.split(' ').join('')} >
                                <span className="underlineThin">
                                  {item.BlogTitle}</span>
                              </Link>
                            </h4>
                            <h5 className="pastBLogDate pt-10">{toBlogDateFormat(item.BlogDate)}</h5>
                            <p className='blogDesc'>{item.BlogDesc}</p>
                            <p className="viewMoreBtn"><Link className="link" to={'/BlogDtl/' + item.BlogId + '/' + item.BlogTitle.split(' ').join('')} >Read More...</Link></p>
                            <h6 className='postBy'>By FintruX Team • 5 mins read</h6>
                            {
                              item.BlogTagName ?
                                (<div className="blogTagContainer"><a className="blogTag" href={"BlogList/"} onClick={() => { this.onTagChange(item.BlogTagId) }}>{item.BlogTagName}</a></div>) : null
                            }
                          </div>
                        </div>
                      }
                    }
                    )}
                  </div>
                </div>
                <div className="btnSec">
                  <a className="blogFullListBtn" href="BlogList/" onClick={() => { this.onTagChange(0) }}>View Full List</a>
                </div>
              </Col>
            </Row>

            {/* <hr /> */}

            {/* <Row>
              <Col md={12}>
                <h2 className='page-title page-title--not-last homeSubTitle'>PAST BLOGS</h2>
              </Col>
              <Col md={12} lg={12} > 
                <div className='catalog-items__wrap pastBlogSec'>
                  <Row>
                    {pastBlogList.map((item, i) => {
                      if (i > 3) {
                        return <Col md={6} lg={6} key={i}>
                          <div className="pastBlogList">
                            <Row>
                              <Col md={6} lg={6}>
                                <div className="imageSec">
                                  <img src={item.PicMed ? ("data:application/base64;base64," + item.PicMed) : ""} alt='catalog-item-img' />
                                </div>
                              </Col>
                              <Col md={6} lg={6}>
                                <div className="pastBLogCnt">
                                  <h5 className="pastBLogDate">{toBlogDateFormat(item.BlogDate)}</h5>
                                  <h4>
                                    <Link className="link" to={'/BlogDtl/' + item.BlogId + '/' + item.BlogTitle.split(' ').join('')} >
                                      <span className="underlineThin">
                                        {item.BlogTitle}</span>
                                    </Link>
                                  </h4>
                                  <h6 className='postBy'>By FintruX Team</h6>
                                  {
                                    item.BlogTagName ?
                                      (<div className="blogTagContainer"><a className="blogTag" href={"BlogList/"} onClick={() => { this.onTagChange(item.BlogTagId) }}>{item.BlogTagName}</a></div>) : null
                                  }
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                      }
                    }
                    )}
                  </Row>
                </div>
                <div className="btnSec">
                  <a className="blogFullListBtn" href="BlogList/" onClick={() => { this.onTagChange(0) }}>View Full List</a>
                </div>
              </Col>
            </Row> */}
          </Container>
        </div>
        );
      };
    };
    
const mapStateToProps = (state) => ({
          user: state.user,
        error: state.error,
        CmnBlog: state.CmnBlog
      });
      
      const mapDispatchToProps = (dispatch) => (
  bindActionCreators(Object.assign({},
    // {LoadPage: LoadPage },
    // {showNotification: showNotification },
    {changeBlogTag: changeBlogTag }
      ), dispatch)
    )
    
    export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/pages/CmnBlog/Home.js